export const TimeArticles_Ar = [
  {
    name: "Berapa hari lagi Ramadan 2026",
    link: "/articles-id/ramadan/",
    description:
      "Kapan awal bulan Ramadan 2026 dalam kalender Hijriah dan Masehi – Kapan Ramadan dimulai – Hitung mundur menuju Ramadan – Berapa hari lagi bulan Ramadan yang penuh berkah.",
    showMain: true,
  },
  {
    name: "Berapa hari lagi Idul Adha 2026",
    link: "/articles-id/eid-adha/",
    description:
      "Temukan di sini hitung mundur Idul Adha, di mana Anda dapat mengetahui berapa hari lagi Idul Adha yang mulia.",
    showMain: true,
  },
  {
    name: "Berapa hari lagi Idul Fitri 2026",
    link: "/articles-id/eid-fatr/",
    description:
      "Temukan di sini hitung mundur Idul Fitri, di mana Anda dapat mengetahui berapa hari lagi Idul Fitri yang mulia.",
    showMain: true,
  },
  {
    name: "Berapa hari lagi Malam Nisfu Syaban 2026",
    link: "/articles-id/shaban/",
    description:
      "Temukan di sini hitung mundur Malam Nisfu Syaban, di mana Anda dapat mengetahui berapa hari lagi Malam Nisfu Syaban.",
    showMain: true,
  },
  {
    name: "Berapa hari lagi Tahun Baru Hijriah 2026",
    link: "/articles-id/hijri/",
    description:
      "Temukan di sini hitung mundur Tahun Baru Hijriah, di mana Anda dapat mengetahui berapa hari lagi Tahun Baru Hijriah.",
    showMain: true,
  },
  {
    name: "Berapa hari lagi Hari Ibu 2026",
    link: "/articles-id/motherday/",
    description:
      "Temukan di sini hitung mundur Hari Ibu, di mana Anda dapat mengetahui berapa hari lagi Hari Ibu.",
    showMain: true,
  },
  {
    name: "Berapa hari lagi Piala Dunia 2026",
    link: "/articles-id/worldcup/",
    description:
      "Temukan di sini hitung mundur menuju dimulainya Piala Dunia 2026.",
    showMain: true,
  },
  {
    name: "Berapa hari lagi Olimpiade 2028",
    link: "/articles-id/olympics/",
    description:
      "Temukan di sini hitung mundur menuju dimulainya Olimpiade 2028.",
    showMain: true,
  },
  {
    name: "Berapa hari lagi Piala Asia 2027",
    link: "/articles-id/asian-cup/",
    description:
      "Temukan di sini hitung mundur menuju dimulainya Piala Asia 2027.",
    showMain: true,
  },
  {
    name: "Berapa hari lagi Tahun Ajaran Baru 2026 di Arab Saudi",
    link: "/articles-id/schooldaySA/",
    description:
      "Temukan di sini hitung mundur tahun ajaran baru 2026 di Arab Saudi, di mana Anda dapat mengetahui berapa hari lagi tahun ajaran baru dimulai.",
    showMain: true,
  },
];
